import React, { ChangeEvent, Component } from 'react';
import FormicaLabel from '../../../custom/FormicaLabel';
import { CustomTriggerJsonModel } from '../../../../domain/tracker/trigger/TriggerJsonModel';
import RoleHelper from '../../../../RoleHelper';
import FormicaInput from '../../../custom/FormicaInput';
import LanguageUtil from '../../../../util/LanguageUtil';

class CustomTriggerComponent extends Component<Props> {
  public render() {
    const { trigger } = this.props;
    return (
      <div className={'border-b py-5'}>
        <div className={'flex flex-col gap-y-1'}>
          <FormicaLabel label={'Event Name'} />
          <FormicaInput
            value={trigger.event}
            name={'Event Name'}
            onChange={this.onChangeEventName}
            type={'text'}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.eventName', defaultMessage: 'Event Name' })}
            disabled={!RoleHelper.canEdit('Tracker')}
          />
        </div>
      </div>
    );
  }

  private onChangeEventName = (e: ChangeEvent<HTMLInputElement>) => {
    const { trigger, onChange } = this.props;
    trigger.event = e.target.value;
    onChange(trigger);
  };
}

interface Props {
  trigger: CustomTriggerJsonModel;
  onChange: (trigger: CustomTriggerJsonModel) => void;
}

export default CustomTriggerComponent;
